// //////////////////////
// Data Model
// //////////////////////

export enum NewsCategory {
  newFeature = "newFeature", // 新機能
  commercialWork = "commercialWork", // 商業作品
  contestCampaign = "contestCampaign", // コンテスト・キャンペーン
  companyBoard = "companyBoard", // 編集部の掲示板
  interview = "interview", // インタビュー
  bugMaintenance = "bugMaintenance", // 不具合・メンテナンス
  other = "other", // その他
  all = "all", // すべて
  uncategorized = "uncategorized", // 未分類・カテゴリなし
}

export interface News {
  id: string;
  title: string;
  text: string;
  createdAt: string;
  updatedAt: string;
  publishedAt?: string;
  revisedAt?: string;
  categoryId?: NewsCategory[]; // MicroCMSの複数選択フィールド（配列として返ってくる）
  categoryCustomText?: string;
}
